import { create } from 'zustand';

export const useToastStore = create((set) => ({

  toasts: [],

  removeToast: (id) =>
    set(state => ({
      toasts: state.toasts.filter(
        toast => toast.id !== id
      )
    })),

  showToast: ({
    type = 'info',
    message,
    duration = 5000
  }) => {

    const id = Date.now() + Math.random();

    set(state => ({
      toasts: [
        ...state.toasts,
        {
          id,
          type,
          message,
          duration
        }
      ]
    }));
  }
}));